import { changeHotel } from 'actions/hotel';
import { getHomeNewsList } from 'actions/news';

import { lanMapRoute, changeLng } from 'util/i18n';

import NewsRoute from './News';

export default store => ({
	path: 'promotions',
	onEnter: () => {
		const {
			hotel: { hotel },
		} = store.getState();

		if (hotel !== 'main') {
			store.dispatch(changeHotel('main'));
		}
	},
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'NewsHome',
			),
		onEnter: ({
			location: {
				query: { page },
			},
		}) => {
			const {
				global: { lan },
			} = store.getState();
			console.log('onEnter');
			store.dispatch(getHomeNewsList(lanMapRoute(lan), { page }));
		},
		onChange: (
			_,
			{
				location: {
					query: { page },
				},
			},
		) => {
			const {
				global: { lan },
			} = store.getState();
			console.log('onChange');
			store.dispatch(getHomeNewsList(lanMapRoute(lan), { page }));
		},
	},
	childRoutes: [
		{
			path: ':lang',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Home').default;
							cb(null, component);
						},
						'NewsHome',
					),
				onEnter: ({
					params: { lang },
					location: {
						query: { page },
					},
				}) => {
					store.dispatch(getHomeNewsList(lanMapRoute(lang), { page }));
				},
				onChange: (
					_,
					{
						params: { lang },
						location: {
							query: { page },
						},
					},
				) => {
					store.dispatch(getHomeNewsList(lanMapRoute(lang), { page }));
				},
			},
			onEnter: ({ params: { lang } }) => {
				const {
					global: { lan },
				} = store.getState();

				if (lanMapRoute(lan) !== lang) {
					changeLng(lang);
				}
			},
			childRoutes: [NewsRoute(store)],
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/News/index.js